import React from 'react';
import { render } from 'react-dom';
import 'locales/i18n';
import 'style/initialize.scss';
import * as serviceWorker from './serviceWorker';
import AppRouter from 'app-router';

render(<AppRouter />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
